import React from "react"

import ArtificialIntelligenceIcon from "../RatePlanner/ArtificialIntelligenceIcon";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";


const NoPriceDialog = ({onClose, openConfigurator}) => {

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    const handleOpenConfigurator = () => {
        onClose();
        setTimeout(openConfigurator, 500);
    }

    return <Dialog open={true}
                   onClose={handleClose}
                   maxWidth="sm">
        <DialogContent>
            <Typography variant="h6" align="justify">
                Non hai ancora impostato nessun prezzo per i prossimi mesi
            </Typography>

            <Grid container spacing={1} mt={2} justifyContent="center"
                  alignItems="center">
                <Grid item md={4} xs={12} sx={{textAlign:"center"}}>
                    <ArtificialIntelligenceIcon sx={{fontSize: 140}} color="primary"/>
                </Grid>
                <Grid item md={8} xs={12}>
                    <Typography variant="body" align="justify" >
                        Configurare i prezzi con il configuratore automatico ti richiede solo pochi secondi
                        e ti permette di ottenere i prezzi più adatti per ogni periodo dell'anno in base
                        alla stagionalità e alla domanda.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body" fontWeight={500} align="justify">
                        Potrai sempre modificare e/o eliminare i prezzi in qualsiasi momento.
                    </Typography>
                </Grid>
            </Grid>
        </DialogContent>

        <DialogActions>
            <Button onClick={onClose} color="primary">
                Magari più tardi
            </Button>
            <Button onClick={handleOpenConfigurator} color="primary" variant="contained">
                Configura ora
            </Button>
        </DialogActions>
    </Dialog>
}

export default NoPriceDialog;